'use client';

import { Reveal } from '../lib/community-reveal';
import type { CommunityLeaderQuote } from '@/types/community';

interface CommunityLeaderQuoteSectionProps {
  zone: CommunityLeaderQuote;
}

export default function CommunityLeaderQuoteSection({ zone }: CommunityLeaderQuoteSectionProps) {
  return (
    <section className="overflow-hidden bg-white px-4 sm:px-6 md:px-16 lg:px-24">
      <div className="container mx-auto max-sm:px-4">
        {zone.heading ? (
          <Reveal direction="up">
            <p className="mb-10 inline-flex items-center gap-2 text-[0.65rem] font-semibold uppercase tracking-[0.28em] text-stone-400">
              <span className="h-px w-6 bg-stone-300" />
              {zone.heading}
            </p>
          </Reveal>
        ) : null}

        <div className="grid gap-8 lg:grid-cols-[auto_1fr] lg:items-start lg:gap-16">
          <Reveal direction="left">
            <span
              className="block select-none font-bold leading-none text-stone-100"
              style={{ fontSize: 'clamp(7rem, 14vw, 13rem)', lineHeight: 0.85 }}
              aria-hidden
            >
              &ldquo;
            </span>
          </Reveal>

          <Reveal direction="right" delay={100}>
            <blockquote>
              {zone.boldText ? (
                <div
                  className="text-xl font-semibold leading-relaxed tracking-tight text-[#1a1a1a] sm:text-2xl [&_p]:mb-0"
                  dangerouslySetInnerHTML={{ __html: zone.boldText }}
                />
              ) : null}
              {zone.description ? (
                <div
                  className="mt-6 max-w-2xl text-sm leading-7 text-stone-600 sm:text-[15px] sm:leading-8 [&_p]:mb-0"
                  dangerouslySetInnerHTML={{ __html: zone.description }}
                />
              ) : null}
              {zone.authorName || zone.authorDesg ? (
                <footer className="mt-8 flex items-center gap-4">
                  <div className="h-10 w-[3px] rounded-full bg-[#ed1c22]" />
                  <div>
                    {zone.authorName ? (
                      <p className="text-base font-bold text-[#1a1a1a]">{zone.authorName}</p>
                    ) : null}
                    {zone.authorDesg ? (
                      <p className="text-sm text-stone-500">{zone.authorDesg}</p>
                    ) : null}
                  </div>
                </footer>
              ) : null}
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
